import axios from '../../plugins/axios'

export const listCalendar = ({ commit }) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = { headers: { Authorization: `Bearer ${token}` } }
  return axios.get('/api/user/me/calendar', config)
    .then((res) => {
        const calendars = res.data
        commit('SET_CALENDARS', { calendars })
        return res
      },
      (err) => {
        commit('SET_CALENDARS', { calendars: [] })
        console.error(err)
        return err.response
      }
    )
}

export const editCalendar = ({}, { id, data }) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = { headers: { Authorization: `Bearer ${token}` } }
  return axios.put(`/api/user/me/calendar/${id}`, data, config)
    .then((res) => res, (err) => err.response)
}


export const listEvent = ({ commit }, timeMin) => {
  if (!timeMin) {
    const date = new Date()
    date.setMonth(date.getMonth() - 1)
    timeMin = date.toISOString()
  }
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = { headers: { Authorization: `Bearer ${token}` } }
  return axios.get(`/api/calendar/event?timeMin=${timeMin}`, config)
    .then((res) => {
        const events = res.data
        commit('SET_EVENTS', { events })
        return res
      },
      (err) => {
        commit('SET_EVENTS', { events: [] })
        console.error(err)
        return err.response
      }
    )
}